<template>
  <div class="list-wrap">
    <el-card class="list-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
        <el-button size="small" type="primary" class="fresh-btn" @click="exportFeedBack">导出</el-button>
      </el-row>
      <!-- 筛选区域 -->
      <el-form :inline="true" :model="search" ref="searchForm" size="mini">
        <el-form-item
          :rules="[{ min:16,max:16, message: '请填写16位的防伪码',trigger: 'blur'}]"
          label="筛选"
          prop="security_code"
        >
          <el-input
            class="select-input"
            placeholder="防伪码"
            size="mini"
            v-model="search.security_code"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input class="select-input" placeholder="用户id" size="mini" v-model="search.ac_id"></el-input>
        </el-form-item>
        <el-form-item
          :rules="[{ min:11,max:11, message: '请填写11位的手机号',trigger: 'blur'}]"
          prop="user_mobile"
        >
          <el-input
            class="select-input"
            placeholder="用户手机"
            size="mini"
            v-model="search.user_mobile"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="查询结果" class="feedback-select" v-model="search.record_type">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="正常"></el-option>
            <el-option :value="2" label="异常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="反馈类型" class="feedback-select" v-model="search.feedback_type">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="商品或经销商不符"></el-option>
            <el-option :value="2" label="我的积分被别人冒领"></el-option>
            <el-option :value="3" label="防伪码不存在或无效"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="处理状态" class="feedback-select" v-model="search.status">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="待处理"></el-option>
            <el-option :value="2" label="已处理"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <el-table
        :data="dataList"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable"
        ref="listTable"
        style="width: 100%"
      >
        <el-table-column label="防伪码" prop="security_code"></el-table-column>
        <el-table-column label="溯源码" prop="traceable_code">
          <template slot-scope="scope">
            <span
              @click="toCodeDetail(scope.row.traceable_code)"
              class="underline cursor"
            >{{scope.row.traceable_code}}</span>
          </template>
        </el-table-column>
        <el-table-column label="查询结果">
          <template slot-scope="scope">
            <span v-if="scope.row.record_type == 1">正常</span>
            <span v-else-if="scope.row.record_type == 2">异常</span>
          </template>
        </el-table-column>
        <el-table-column label="用户反馈类型">
          <template slot-scope="scope">
            <span v-if="scope.row.feedback_type == 1">商品或经销商不符</span>
            <span v-else-if="scope.row.feedback_type == 2">我的积分被别人冒领</span>
            <span v-else-if="scope.row.feedback_type == 3">防伪码不存在或无效</span>
          </template>
        </el-table-column>
        <el-table-column label="反馈详情">
          <template slot-scope="scope">
            <el-button
              @click="showMedia(scope.row.image)"
              class="c-blue cursor"
              type="text"
              v-if="scope.row.image"
            >[附件]</el-button>
            <p>
              <span>商品名：</span>
              {{scope.row.goods_name}}
            </p>
            <p>
              <span>店铺：</span>
              {{scope.row.dealer}}
            </p>
            <p>
              <span>地址：</span>
              {{scope.row.dealer_address}}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="leave_comments"></el-table-column>
        <el-table-column label="用户">
          <template slot-scope="scope">
            <p>
              <span>id：</span>
              <span
                @click="toUserDetail(scope.row.user_info.ac_id)"
                class="underline cursor"
              >{{scope.row.user_info.ac_id}}</span>
            </p>
            <p>
              <span>手机：</span>
              {{scope.row.user_info.mobile}}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="客服备注" prop="note"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <p v-if="scope.row.status ==1">待处理</p>
            <p v-else-if="scope.row.status==2">已处理</p>
          </template>
        </el-table-column>
        <el-table-column label="反馈时间" prop="feedback_time"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="showRemark(scope.row.id)"
              size="mini"
              type="text"
            >{{scope.row.status==1?'处理':'备注'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          :page-size="page.pageSize"
          :total="page.total"
          @current-change="onChangePage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 备注 -->
    <el-dialog :visible.sync="remark.show" title="备注" width="500px">
      <el-form :model="remark" label-width="80px" ref="remarkForm">
        <el-form-item :rules="{required: true, message: '请填写备注内容'}" label="备注内容" prop="note">
          <el-input type="textarea" v-model="remark.note"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onRemark" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>
    </el-dialog>
    <viewMedia :imglist="viewMedia" ref="viewPicture"></viewMedia>
  </div>
</template>

<script>
  import viewMedia from "@/components/common/viewMedia";
  import {feedbackApi} from "@/api/feedback/";
  import lodash from "lodash";

  const tempSearch = {
  security_code: "", //	否	string	防伪码	筛选条件
  ac_id: "", //	否	int	用户ID	筛选条件
  user_mobile: "", //	否	int	用户手机号	筛选条件
  record_type: undefined, //	否	int	查询结果状态	筛选条件 1=正常 2=异常
  feedback_type: undefined, //	否	int	异常类型	筛选条件 1=商品或经销商不符 2=我的积分被别人冒领 3=防伪码不存在或无效
  status: undefined // 否	int	处理状态	筛选条件 1=待处理 2=已处理
};
export default {
  components: {
    viewMedia
  },
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      viewMedia: [],
      search: lodash.cloneDeep(tempSearch),
      dataList: [],
      remark: {
        id: "",
        note: "",
        show: false
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList(page) {
      const params = {
        page,
        per_page: this.page.pageSize,
        ...this.search
      };
      return this.$EpetJs.Common.get(feedbackApi.getList, params, {
        needLoading: true
      }).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
            this.page.currentPage = res.data.meta.pagination.current_page;
          }
        }
        return res;
      });
    },
    //刷新
    fresh() {
      this.getList();
    },
    //导出
    exportFeedBack() {
      const params = {
        ...this.search
      };
      this.$EpetJs.Common.get(feedbackApi.exportFeedBackUrl, params).then(
        res => {
          if (res) {
            this.$message.success("操作成功，请去导出列表查看！");
          }
        }
      );
    },
    /**
     * remark dialog
     */
    showRemark(id) {
      this.remark = {
        id,
        show: true,
        note: ""
      };
      this.$nextTick(() => {
        this.$refs["remarkForm"].clearValidate();
      });
    },
    /**
     * 提交备注
     */
    onRemark() {
      return this.$refs["remarkForm"].validate(async valid => {
        if (!valid) return;
        const params = {
          type: this.remark.type,
          note: this.remark.note
        };
        await this.$EpetJs.Common.patch(
          feedbackApi.addRemark + this.remark.id,
          params,
          {
            needLoading: true
          }
        ).then(res => {
          if (res) {
            this.dataList = res.data.data;
            if (res.data.meta && res.data.meta.pagination) {
              this.page.total = res.data.meta.pagination.total;
            }
          }
          return res;
        });
        await this.getList(this.page.currentPage);
        this.remark.show = false;
      });
    },
    /**跳转用户详情 */
    toUserDetail(ac_id) {
      this.$router.push({
        path: "/client_user/detail/" + ac_id
      });
    },
    /**跳转贴纸详情 */
    toCodeDetail(id) {
      this.$router.push("/sticker/detail/" + id);
    },
    /**
     * 当前页改变
     */
    onChangePage(val) {
      this.getList(val);
    },
    /**
     * 筛选
     */
    onSearch() {
      this.$refs["searchForm"].validate(valid => {
        if (!valid) return;
        this.getList();
      });
    },
    // 查看附件
    showMedia(img) {
      this.viewMedia = [{ url: img }];
      this.$refs.viewPicture.showViewPicture = true;
    },
    /**
     * 重置
     */
    onReset() {
      this.search = lodash.cloneDeep(tempSearch);
      this.getList();
    }
  }
};
</script>
<style lang="less">
.select-input,
.feedback-select {
  width: 110px;
}
.list-wrap {
  .list-body {
    min-height: calc(100vh - 60px);
    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>
